import { bm } from '@core-utils/bem';

import styles from './AlertBanner.module.scss';

export const alertBannerStyles = {
    blockScope: styles.AlertBanner,
    infoAlert: styles[bm('AlertBanner', 'info')],
    warningAlert: styles[bm('AlertBanner', 'warning')],
    errorAlert: styles[bm('AlertBanner', 'error')],
    exitingAlert: styles[bm('AlertBanner', 'exiting')],
};
